/**
 * Every blank the operator has to fill, in one place. Nothing here is invented
 * and nothing here ships as a number until the operator sets it.
 */
export const OPERATOR_COMPANY = "Geometri Technologies";
export const OPERATOR_ADDRESS = "[OPERATOR: registered address]";
export const OPERATOR_UK_REP = "[OPERATOR: UK representative]";
export const OPERATOR_EMAIL = "[OPERATOR: contact email]";
export const OPERATOR_RETENTION = "[OPERATOR: how long we keep it, in plain words]";
export const OPERATOR_ICO = "[OPERATOR: ICO registration number]";
/* Two more, moved here by the wave 2 integrator on 5 September 2026 from the
   top of Privacy.tsx, where V5-C left them because this file belonged to
   nobody that wave. A lawful basis and a transfer safeguard are legal
   determinations about a company, and inventing either would put a claim in a
   privacy notice that nobody has made. */
export const OPERATOR_LAWFUL_BASIS =
  "[OPERATOR: the lawful basis for reading a child's work, in one sentence]";
export const OPERATOR_TRANSFER =
  "[OPERATOR: where the model runs, and the safeguard for sending it there]";
export const OPERATOR_REFUND = "[OPERATOR: refund terms]";
/* Prices and the monthly plan's size were blanks here until 4 September 2026.
   They are now real numbers and they live in `src/lib/plans.ts`, which is the
   one place a price is written. Nothing about money belongs in this file. */
